import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import Login from "@/pages/Login";
import CafeteriaView from "@/pages/CafeteriaView";
import KitchenView from "@/pages/KitchenView";
import AdminView from "@/pages/AdminView";
import PlannerView from "@/pages/PlannerView";
import StoreView from "@/pages/StoreView";

function FullLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}

const homeFor = (role) => ({ admin: "/admin", kitchen: "/kitchen", store: "/store", planner: "/planner" }[role] || "/cafeteria");

function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={homeFor(user.role)} replace />;
  }
  return children;
}

function Landing() {
  const { user, loading } = useAuth();
  if (loading || user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={homeFor(user.role)} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cafeteria" element={<Protected roles={["cafeteria", "admin"]}><CafeteriaView /></Protected>} />
          <Route path="/kitchen" element={<Protected roles={["kitchen", "admin"]}><KitchenView /></Protected>} />
          <Route path="/store" element={<Protected roles={["store", "admin"]}><StoreView /></Protected>} />
          <Route path="/admin" element={<Protected roles={["admin"]}><AdminView /></Protected>} />
          <Route path="/planner" element={<Protected roles={["planner"]}><PlannerView /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
